<script>
    import Property from "./Property.svelte";
    export let dataMapped;

    $: value = (dataMapped && dataMapped.value) || {};
    $: header = (dataMapped && dataMapped.header) || {};

    const propertyKeys = [
        'pMTxt',
        'siblingTextureTxt',
        'rockClassRock2',
        'rockClassFines2',
        'pMOriginTxt',
        'siblingDepthTxt',
        'depthRange'
    ];

    const links = new Map([
        ['pMTxt', 'https://smap.landcareresearch.co.nz/glossary-for-stuv#soil_profile_material'],
        ['siblingTextureTxt', 'https://smap.landcareresearch.co.nz/glossary-for-pqr#texture_profile'],
        ['rockClassRock2', 'https://smap.landcareresearch.co.nz/glossary-for-pqr#rock_class_of_stones/rocks'],
        ['rockClassFines2', 'https://smap.landcareresearch.co.nz/glossary-for-stuv#rock_origin_of_fine_earth'],
        ['pMOriginTxt', 'https://smap.landcareresearch.co.nz/glossary-for-pqr#parent_material%20origin'],
        ['siblingDepthTxt', 'https://smap.landcareresearch.co.nz/glossary-for-def#depth_class'],
        ['depthRange', 'https://smap.landcareresearch.co.nz/glossary-for-def#depth_class']
    ]);

    $: longSoilDescription = (value.longSoilDescription || '')
        .replace(/\r/, "")
        .split(/\n/)
        .map(t => t.trim())
        .filter(t => !!t);
</script>

<div class="soil-classification-outer">
    <div class="sibling-classification">
        <div class="classification-node" data-key="nzscDescription">
            <Property title="Soil classification:" text={value.nzscDescription || ''}/>
            <div class="classification-node" data-key="familyName">
                <Property title="Family name:" text={ value.familyName || '' }/>
                <div class="classification-node" data-key="fullSmapName">
                    <Property title="Sibling name:" text={ value.fullSmapName || '' }/>
                </div>
            </div>
        </div>
    </div>

    {#if header && value}
        <div class="properties">
            {#each propertyKeys as k}
                {#if header[k] && value[k]}
                    <div data-key={k}>
                        <Property title={header[k]}
                                  text={value[k]}
                                  href={links.get(k)}/>
                    </div>
                {/if}
            {/each}
        </div>
    {/if}
</div>

<div class="long-soil-description-outer">
    <div class="long-soil-description">
        {#each longSoilDescription as section}
            <p>
                { section.trim() }
            </p>
        {/each}
    </div>

    {#if dataMapped && dataMapped.soilGroupSketchUrl}
        <div style="text-align: center;">
            <!-- TODO: better alt text -->
            <img src={dataMapped.soilGroupSketchUrl} alt="An illustration of the soil"/>
        </div>
    {/if}
</div>

<style>
    .classification-node > .classification-node {
        margin-left: 20px;
    }

    @media (min-width: 768px) {
        .soil-classification-outer {
            display: flex;
        }

        .sibling-classification {
            flex: 1;
        }

        .properties {
            padding: 0 1em;
            flex: 1;
        }
    }

    @media (min-width: 400px) {
        .long-soil-description-outer {
            display: flex;
        }

        .long-soil-description {
            padding-top: 11px;
        }

        .long-soil-description-outer > div {
            flex: 1;
        }
    }

    @media print {
        .soil-classification-outer {
            display: flex;
        }

        .sibling-classification {
            flex: 1;
        }

        .properties {
            padding: 0 1em;
            /*flex: 1;*/
        }

        .long-soil-description-outer {
            break-inside: avoid;
            display: flex;
        }

        .long-soil-description-outer > div {
            flex: 1;
        }
    }
</style>
